<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
export default {
  name: "App",
  components: { Header, Footer },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style lang="scss">
@import "./components/App.scss";
</style>
